import convertAttachmentToInlineOperation from 'owa-service/lib/operation/convertAttachmentToInlineOperation';
import ConvertAttachmentToInlineRequest from 'owa-service/lib/contract/ConvertAttachmentToInlineRequest';
import ConvertAttachmentToInlineResponse from 'owa-service/lib/contract/ConvertAttachmentToInlineResponse';
import ItemId from 'owa-service/lib/contract/ItemId';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { trace } from 'owa-trace';

export default async function ConvertAttachmentToInline(
    attachment: AttachmentFullViewState,
    parentItemId: ItemId
): Promise<string> {
    // Place ContentId on image.
    const request: ConvertAttachmentToInlineRequest = {
        ewsAttachmentId: attachment.attachmentId,
        itemId: parentItemId.Id,
    };

    try {
        const response: ConvertAttachmentToInlineResponse = await convertAttachmentToInlineOperation(
            {
                requestObject: request,
            }
        );

        if (response.ErrorMessage) {
            trace.warn(
                'Failed to convert image attachment to inline, error message: ' +
                    response.ErrorMessage
            );
        } else {
            return response.ContentId;
        }
    } catch (e) {
        trace.warn(
            'Failed to move image attachment to the message body, error message: ' + e.message
        );
    }

    return null;
}
